import Server from '@/service/server'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  actions: {
    track (context: any, clickId: string) {
      let promise = Server.trackSabaAd({ clickId: clickId })
      promise.then((response: any) => {
        // TODO:
      })
      return promise
    }
  },
  mutations: {

  }
}
